<template>
  <div>
    <textarea 
      ref="templateEditorArea"
      class="form-control message-template-editor"
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      v-bind:placeholder="placeholder"
      v-bind:class="{'is-invalid': hasError()}"
      :rows="rows" />
    <div class="form-invalid-feedback" v-if="hasError()">
      {{getError()}}
    </div>
    <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
  </div>
</template>

<style scoped>
.message-template-editor {
  font-size: 0.8rem;
}
</style>

<script>
import formField from '@/mixins/formField'

export default {
  name: 'MessageTemplateEditor',
  mixins: [formField],
  props: {
    value: String,
    placeholder: String,
    field: String,
    rows: {
      type: Number,
      default: 10
    },
    note: String
  },
  watch: {
    value: function(newVal, oldVal) {
      // Default to empty string if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('input', '')
        })
      }
    }
  },
  mounted() {
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    insertPlaceholder(code) {
      var startPos = this.$refs.templateEditorArea.selectionStart
      var endPos = this.$refs.templateEditorArea.selectionEnd
      var cursorPos = startPos
      var curValue = this.$props.value ? this.$props.value : ''

      var placeholder = `[${code}]`
      
      var updatedContent = curValue.substring(0, startPos) + placeholder + curValue.substring(endPos, curValue.length)

      this.$emit('input', updatedContent)

      // Move cursor
      setTimeout(() => {
        cursorPos += placeholder.length
        this.$refs.templateEditorArea.selectionStart = this.$refs.templateEditorArea.selectionEnd = cursorPos
      }, 10)
    }
  }
};
</script>